import { gql } from '@apollo/client';
import { DatasetCreateFormData } from 'types/Forms';

const importDataset = (formData: DatasetCreateFormData) => ({
    variables: {
        input: formData,
    },
    mutation: gql`
        mutation ImportDataset($input: ImportDatasetInput) {
            importDataset(input: $input) {
                datasetUri
                label
            }
        }
    `,
});

export default importDataset;
